export { Chat } from "./Chat";

export {Chat as SupportChat} from './Chat'